<template>
  <v-dialog
    v-model="isDialogOpened"
    :content-class="'white-two ' + ($vuetify.breakpoint.mdAndUp ? 'dialog' : 'dialog-mobile')"
    :eager="true"
    @input="closeModal()">
    <v-card
      class="pa-6 card"
      :style="$vuetify.breakpoint.mdAndUp ? '' : 'box-shadow: none !important; -webkit-box-shadow: none !important;'">
      <v-card-text class="pa-0">
        <LeadForm v-model="formData" :onClose="closeModal" @handleFormValid="handleFormValid" />
      </v-card-text>
      <v-card-actions class="pa-0 pt-6 mb-2">
        <button
          class="submit-button white-two--text rounded-lg"
          :style="{ opacity: !isFormValid ? '0.2' : '1' }"
          flat
          :disabled="!isFormValid"
          @click="submitForm">
          무료 상담하기
        </button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LeadForm from '@/components/company/lead/LeadForm.vue';
import axios from 'axios';

export default {
  name: 'LeadModal',
  components: {
    LeadForm,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      formData: {
        type: 'STORE',
        name: '',
        x: '',
        y: '',
        contact: '',
        roadAddress: '',
        isPrivacyAgreed: false,
        isMarketingAgreed: false,
      },
      isFormValid: false,
    };
  },

  computed: {
    isDialogOpened: {
      get() {
        return this.showModal;
      },
      set(value) {
        this.$emit('update:showModal', value);
      },
    },
  },

  methods: {
    handleFormValid(isValid) {
      this.isFormValid = isValid;
    },
    updateForm(data) {
      this.formData = { ...this.formData, ...data };
    },
    closeModal() {
      this.isDialogOpened = false;
    },
    async submitForm() {
      try {
        const response = await axios
          .post('/marketing-lead', {
            companyName: this.formData.name,
            adCategory: this.formData.type,
            contact: this.formData.contact,
            agreeToMarketing: this.formData.isMarketingAgreed,
            x: this.formData.x,
            y: this.formData.y,
            ...(this.formData.roadAddress && { address: this.formData.roadAddress }),
          })
          .then(res => {
            return res.data;
          });

        if (response.data) {
          const leadId = response.data.id;
          const companyName = this.formData.name;
          const x = this.formData.x;
          const y = this.formData.y;

          let uri = '/leadcomplete';
          const utm =
            'leadsource=landing_top&utm_source=organic-internal&utm_medium=link&utm_campaign=sm_company&utm_term=mkt-lead&utm_content=250414';

          if (leadId) {
            uri += `?leadId=${leadId}&type=${this.formData.type}&companyName=${companyName}`;
            if (x && y) {
              uri += `&x=${x}&y=${y}&${utm}`;
            } else {
              uri += `&${utm}`;
            }
          } else {
            uri += `?${utm}`;
          }

          this.$router.push(uri);
        }

        this.closeModal();
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-dialog {
  min-width: 375px !important;
}

::v-deep .dialog {
  width: 375px;
  border-radius: 20px !important;
}

::v-deep .dialog-mobile {
  width: 100%;
  min-width: 100% !important;
  min-height: 100% !important;

  display: flex;
  justify-content: center;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.card {
  width: 375px;
  min-width: 375px !important;
}

.submit-button {
  width: 100%;
  height: 44px;
  border-radius: 4px;
  background-color: var(--primary-light-color);
  color: white;
}
</style>
